const ListTable = require('app/ui/list/Table');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-product-price-logs',
            'tableContainerSelector': '.product-logs-container',
            'filterFormSelector': '.product-logs-search-form',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
        this.initializeListTable();
    }

    initializeFilterForm(){
        var self = this;

        this.$filterByNumber = $('input[name="number"]',this.$filterForm);
        this.$filterByNumber.on('change',this.onSubmitFilterForm);

        this.$filterByReference = $('input[name="reference"]',this.$filterForm);
        this.$filterByReference.on('change',this.onSubmitFilterForm);

        this.$filterByRestaurant = $('select[name="restaurant"]',this.$filterForm);
        this.$filterByRestaurant.on('change',this.onSubmitFilterForm);

        this.$filterByUser = $('select[name="user"]',this.$filterForm);
        this.$filterByUser.on('change',this.onSubmitFilterForm);

        this.$filterForm.on('submit',this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }


    initializeListTable(){
        var self = this;

        let fields = [
            'createdAt',
			'user{ firstName lastName }',
			'product { number reference }',
			'type',
			'restaurant { id name }',
			'oldPrice',
			'newPrice',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped product-list',
            'id': 'list-products',
            'length': 50,
            'graphQL': {
                'queryType': 'restaurantProductPriceUpdateLogs',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': 'Le',
                    'orderType': 'createdAt',
                    'class': 'log-createdAt',
                    'render': function(item,index){
                        return item.node.createdAt;
                    },
                },
                {
                    'name': 'user',
                    'label': 'Utilisateur',
                    'ordered': true,
                    'orderType': 'user',
                    'orderDir': 'ASC',
                    'class': 'log-user',
                    'render': function(item,index){
                        return item.node.user.firstName + ' ' + item.node.user.lastName;
                    },
                },
                {
                    'name': 'product',
                    'label': 'Produit',
                    'ordered': true,
                    'orderType': 'product',
                    'orderDir': 'ASC',
                    'class': 'log-product',
                    'render': function(item,index){
                        return item.node.product.number + ' ' + item.node.product.reference;
                    },
                },
                {
                    'name': 'type',
                    'label': 'Type',
                    'ordered': true,
                    'orderType': 'type',
                    'orderDir': 'ASC',
                    'class': 'log-type',
                    'render': function(item,index){
						if(item.node.type == 1)
                        	return 'P.V.';
						else
                        	return 'P.A.';
                    },
                },
                {
                    'name': 'restaurant',
                    'label': 'Restaurant',
                    'ordered': true,
                    'orderType': 'restaurant',
                    'orderDir': 'ASC',
                    'class': 'log-restaurant',
                    'render': function(item,index){
						if(item.node.restaurant.id == 0)
							return '-';
						else
                        	return item.node.restaurant.name;
                    },
                },
                {
                    'name': 'oldPrice',
                    'label': 'Ancien prix',
                    'ordered': false,
                    'class': 'log-oldPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.node.oldPrice,4) + ' &euro;';
                    },
                },
                {
                    'name': 'newPrice',
                    'label': 'Nouveau prix',
                    'ordered': false,
                    'class': 'log-newPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.node.newPrice,4) + ' &euro;';
                    },
                }
            ]
        })
    }

    buildGraphQLParameters(){
        let filters = {
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = '%'+this.$filterByReference.val()+'%';
        }

        if(this.$filterByRestaurant && this.$filterByRestaurant.val()){
            filters.restaurant = parseInt(this.$filterByRestaurant.val());
        }

        if(this.$filterByUser && this.$filterByUser.val()){
            filters.user = parseInt(this.$filterByUser.val());
        }

        let orderBy = 'createdAt';
        let dir = "DESC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }
}

module.exports = ListView;

